import {put, takeEvery, select} from 'redux-saga/effects';
import {
	acceptTerms,
	applyPromocode,
	deleteCard,
	emailReceipts,
	getRestaurantListByZip, initApplePayPayment, initGooglePayPayment,
	registerStripeCard,
	resendPhoneCode,
	sendReceipt,
	setTable,
} from 'new-actions/api.actions.ts';
import {
	CANCEL_ADYEN_CARD_REGISTRATION_POPUP, CANCEL_STRIPE_THREE_DS_POPUP,
	CONFIRM_VERIFICATION_CODE_RESEND,
	DONE_CARD_STATUS,
	DONE_DELIVERY_ADDRESS,
	DONE_EMAIL_ALL_RECEIPTS,
	DONE_EMAIL_RECEIPT,
	DONE_PROMOCODE,
	DONE_TABLE_EDIT,
	DONE_TERMS,
	DONE_ZIP_EDIT,
	OPEN_CARD_STATUS,
	OPEN_DELETE_CARD,
} from 'new-constants/popup.constants';
import {
	ACCEPT_TERMS_SUCCESS,
	CHECK_PHONE_CODE_SUCCESS,
	SET_BIRTHDATE_SUCCESS,
	SET_EMAIL_SUCCESS,
	SET_NAME_SUCCESS,
} from 'new-constants/api.constants';
import {openRegistrationPopup} from 'new-actions/popup.actions';
import {getRegistrationPopup} from 'helpers/customer.helper';
import {
	getCurrentCustomerSelector,
	getCurrentRestaurantIdSelector,
	getCurrentRestaurantSelector, getCurrentTemporaryOrderIdSelector,
	getCurrentTemporaryOrderLinesSelector,
} from '../selectors';
import {
	PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
} from 'new-components/popups/stripe-card-registration/StripeCardRegistration';
import {
	CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_VIPPS_PAYMENT_FRAME, DONE_ZIP_EDIT_FROM_CART, DONE_REPEAT_ORDER_CONFIRMATION,
	DONE_SERVER, DONE_DELIVERY_ADDRESS_FROM_CART, DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION, ADYEN_CARD_REGISTRATION_POPUP
} from "../constants/popup.constants";
import {
	cancelOrder,
	getOrder,
	initAdyenCardPayment,
	initSwishPayment,
	markPopupAsShown,
	registerAdyenCard,
	repeatOrder
} from "../actions/api.actions";
import {CANCEL_ORDER, ORDER, ORDER_SUCCESS} from "../constants/api.constants";
import {history} from 'new-components/router/history';
import {getOrderRoute} from "../helpers/routes.helper";
import {APPLE_PAY_SUBMIT, GOOGLE_PAY_SUBMIT, SUBMIT_ADYEN_CARD_REGISTER, SWISH_PAY_SUBMIT} from "../constants/payment.constants";

function* validateZip(action) {
	yield put(getRestaurantListByZip(action.zip, false, false, action.isCheckDeliveryAddress));
}

function* validateZipFromCart(action) {
	yield put(getRestaurantListByZip(action.zip, true, false, action.isCheckDeliveryAddress ));
}

function* validatePromocode(action) {
	yield put(applyPromocode(action.promocode));
}

function* validateTable(action) {
	yield put(setTable(action.tableNumber));
}

function* sendDeleteCard() {
	yield put(deleteCard());
}

function* requestEmailReceipts(action) {
	yield put(emailReceipts(action.email, action.isSubscribe, true));
}

function* requestSendReceipt(action) {
	yield put(sendReceipt(action.orderId, action.email, action.isSubscribe));
}

function* requestVerificationCodeResend() {
	yield put(resendPhoneCode());
}

function* openNextRegistrationPopupIfNecessary() {
	const state = yield select();
	
	const registrationPopup = getRegistrationPopup(
		getCurrentCustomerSelector(state),
		getCurrentRestaurantSelector(state)
	);
	
	if (getCurrentTemporaryOrderLinesSelector(state)) {
		yield put(openRegistrationPopup(registrationPopup, getCurrentRestaurantIdSelector(state)));
	}
}

function* requestNewCardRegistration(action) {
	if (action.showPopup !== PROFILE_STRIPE_CARD_REGISTRATION_POPUP) {
		return;
	}
	yield put(registerStripeCard());
}

function* sendTermsConsent(action) {
	yield put(acceptTerms(action.marketingConsent));
}

function* cancelTemporaryStripeOrder() {
	const state = yield select();
	const currentTemporaryOrderId = getCurrentTemporaryOrderIdSelector(state);
	
	if (currentTemporaryOrderId && !state.fetchProgress[CANCEL_ORDER]) {
		yield put(cancelOrder(currentTemporaryOrderId));
	}
}

function* cancelTemporaryAdyenOrder() {
	const state = yield select();
	const currentTemporaryOrderId = getCurrentTemporaryOrderIdSelector(state);

	if (currentTemporaryOrderId && !state.fetchProgress[CANCEL_ORDER]) {
		yield put(cancelOrder(currentTemporaryOrderId));
	}
}

function* checkTemporaryVippsOrderBeforeCancel() {
	const state = yield select();
	
	const currentTemporaryOrderId = getCurrentTemporaryOrderIdSelector(state);
	
	if (currentTemporaryOrderId && !state.fetchProgress[CANCEL_ORDER] && !state.fetchProgress[ORDER]) {
		yield put(getOrder(currentTemporaryOrderId, true))
	}
}

function* cancelTemporaryVippsOrderIfNeeded(action) {
	if (!action.payload.isScheduledForCancel) {
		return;
	}
	
	if (action.payload.data.order.isPaid) {
		history.replace(
			getOrderRoute(action.payload.data.order.orderId, true)
		);
	} else {
		yield put(cancelOrder(action.payload.data.order.orderId));
	}
}

function* sendMarkPopupAsShown(action) {
	yield put(markPopupAsShown(action.popupId));
}

function* checkOrderRepeatFromOrderPage(action) {
	yield put(repeatOrder(action.orderId, true));
}

function* checkOrderRepeatFromHistoryPage(action) {
	yield put(repeatOrder(action.orderId));
}

function* submitAdyenCardRegister(action) {
	yield put(initAdyenCardPayment(action.data, action.redirectToOrder));
}
function* submitSwishPayment(action) {
	yield put(initSwishPayment(action.data, action.redirectToOrder));
}
function* requestNewAdyenCardRegistration(action) {
	if (action.showPopup !== ADYEN_CARD_REGISTRATION_POPUP) {
		return;
	}
	yield put(registerAdyenCard(action.paymentMethod));
}

function* submitGooglePayPayment(action) {
	yield put(initGooglePayPayment(action.data));
}

function* submitApplePayPayment(action) {
	yield put(initApplePayPayment(action.data));
}

export const popupSaga = function* popupSaga() {
	yield takeEvery([SUBMIT_ADYEN_CARD_REGISTER], submitAdyenCardRegister);
	yield takeEvery([SWISH_PAY_SUBMIT], submitSwishPayment);
	yield takeEvery([GOOGLE_PAY_SUBMIT], submitGooglePayPayment);
	yield takeEvery([APPLE_PAY_SUBMIT], submitApplePayPayment);
	
	yield takeEvery(
		action => (action.type === DONE_DELIVERY_ADDRESS || action.type === DONE_ZIP_EDIT) && action.zip,
		validateZip
	);
	yield takeEvery(
		action => (action.type === DONE_DELIVERY_ADDRESS_FROM_CART || action.type === DONE_ZIP_EDIT_FROM_CART) && action.zip,
		validateZipFromCart
	);
	yield takeEvery([DONE_PROMOCODE], validatePromocode);
	yield takeEvery([DONE_TABLE_EDIT], validateTable);
	yield takeEvery([OPEN_DELETE_CARD], sendDeleteCard);
	yield takeEvery([DONE_EMAIL_ALL_RECEIPTS], requestEmailReceipts);
	yield takeEvery([DONE_EMAIL_RECEIPT], requestSendReceipt);
	yield takeEvery([CONFIRM_VERIFICATION_CODE_RESEND], requestVerificationCodeResend);
	yield takeEvery(
		[CHECK_PHONE_CODE_SUCCESS, SET_NAME_SUCCESS, SET_EMAIL_SUCCESS, SET_BIRTHDATE_SUCCESS, ACCEPT_TERMS_SUCCESS],
		openNextRegistrationPopupIfNecessary
	);
	yield takeEvery(
		[
			DONE_CARD_STATUS,
			action => action.type === OPEN_CARD_STATUS && action.showPopup === PROFILE_STRIPE_CARD_REGISTRATION_POPUP,
		],
		requestNewCardRegistration
	);
	yield takeEvery(
		[
			DONE_CARD_STATUS,
			action => action.type === OPEN_CARD_STATUS && action.showPopup === ADYEN_CARD_REGISTRATION_POPUP,
		],
		requestNewAdyenCardRegistration
	);
	yield takeEvery([DONE_TERMS], sendTermsConsent);
	yield takeEvery([CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_STRIPE_THREE_DS_POPUP], cancelTemporaryStripeOrder);
	yield takeEvery([CANCEL_ADYEN_CARD_REGISTRATION_POPUP], cancelTemporaryAdyenOrder);
	yield takeEvery([CANCEL_VIPPS_PAYMENT_FRAME], checkTemporaryVippsOrderBeforeCancel);
	yield takeEvery([ORDER_SUCCESS], cancelTemporaryVippsOrderIfNeeded);
	yield takeEvery([DONE_SERVER], sendMarkPopupAsShown);
	yield takeEvery([DONE_REPEAT_ORDER_CONFIRMATION], checkOrderRepeatFromOrderPage);
	yield takeEvery([DONE_REPEAT_ORDER_FROM_HISTORY_CONFIRMATION], checkOrderRepeatFromHistoryPage);
};
